var __jsx = React.createElement;
import { PageLayout } from "../../util/constants";
import dynamic from "next/dynamic";
import Head from "next/head";
import React from "react";
import i18next from "i18next";
import { useStore } from "@dp/state";
import { useEffect } from "react";
import { useRouter } from "next/router";
var UnsubEclub = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.UnsubElub;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var UnsubEclubPage = function UnsubEclubPage(props) {
  var store = useStore();
  var router = useRouter();
  var emailParam = router.query.email_id;
  var email = emailParam ? decodeURIComponent(emailParam.replace(/ /g, "+")) : "";
  useEffect(function () {
    var _store$initComponent;
    store === null || store === void 0 || (_store$initComponent = store.initComponent("Eclub")) === null || _store$initComponent === void 0 || _store$initComponent.then(function () {
      // NOOP
    });
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("title.unsubscribe.pagetitle", {
    defaultValue: "Unsubscribe"
  }))), __jsx(UnsubEclub, {
    encryptedEmail: email
  }));
};
UnsubEclubPage.layout = PageLayout.NB_LAYOUT;
export default UnsubEclubPage;